<div class="dialog-content">
  @let showInfoBox = isInvoiced() || selectedTimeBlock().timeBlockModel.isActive;

  @if (showInfoBox) {
    <ng-container
      [ngTemplateOutlet]="msgBox"
      [ngTemplateOutletContext]="{ innerTemplate: msgContent }"
    ></ng-container>

    <ng-template #msgContent>
      @if (isInvoiced()) {
        Zeiteintrag wurde bereits in Rechnung gestellt: <a href="#">Rechnung</a>
      }
      @if (selectedTimeBlock().timeBlockModel.isActive) {
        Ein aktiver Zeiteintrag kann nicht in der Zukunft liegen.
      }
    </ng-template>
  }

  <form class="k-form" [formGroup]="projectTypeForm()">
    <kendo-formfield orientation="horizontal">
      <kendo-label class="!k-align-items-start" [for]="project" text="Projekt"></kendo-label>
      <kendo-dropdownlist
        [showStickyHeader]="false"
        [data]="projects$ | async"
        textField="text"
        valueField="value"
        [formControlName]="formControlNames.Project"
        (selectionChange)="projectChanged($event)"
        #project
      >
      </kendo-dropdownlist>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="!k-align-items-start" [for]="task" text="Aufgabe"></kendo-label>
      <kendo-dropdownlist
        [data]="tasks"
        textField="text"
        valueField="value"
        [formControlName]="formControlNames.Task"
        #task
      >
      </kendo-dropdownlist>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label
        class="!k-align-items-start !k-justify-content-flex-start k-mt-2"
        [for]="description"
        text="Beschreibung"
      ></kendo-label>
      <kendo-textarea
        [formControlName]="formControlNames.Description"
        style="height: calc(1.5em * 3)"
        resizable="auto"
        #description
      >
      </kendo-textarea>
    </kendo-formfield>

    <app-date-and-time-input-dialog
      [workTimeStart]="workTimeStart()"
      [workTimeEnd]="workTimeEnd()"
      [timeBlock]="selectedTimeBlock()"
      [form]="projectTypeForm()"
      [(fixIntervalDropdownVisible)]="fixIntervalDropdownVisible"
      [intervalSelectable]="true"
    ></app-date-and-time-input-dialog>
  </form>
</div>

<ng-container [ngTemplateOutlet]="footer()" />

<ng-template #msgBox let-innerTemplate="innerTemplate">
  <div class="k-messagebox k-messagebox-info k-d-grid k-gap-2 k-mb-6">
    <fa-icon [icon]="faInfoCircle" class="info-icon"></fa-icon>
    <span class="info-text">
      <ng-container *ngTemplateOutlet="innerTemplate"></ng-container>
    </span>
  </div>
</ng-template>
